import { styled } from '@mui/material';

export const Container = styled('div')`
  background-color: white;
  padding: 1rem;
  border-left: 1px solid #ebebee;
`;

export const Button = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean | undefined }>(({ theme, active }) => ({
  padding: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.25rem',
  cursor: 'pointer',
  backgroundColor: active ? theme.palette.blue[50] : 'white',

  '&>p': {
    color: active ? theme.palette.blue[600] : theme.palette.grey[900],
  },

  '& > svg > path': {
    fill: active ? theme.palette.blue[600] : theme.palette.grey[900],
  },
}));

export const Label = styled('p')(({ theme }) => ({
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  margin: 0,
  color: theme.palette.grey[900],

  WebkitUserSelect: 'none',
  userSelect: 'none',
  msUserSelect: 'none',
}));
